import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Astronomy = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-astro.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Astronomy"
                breadEnd="Learning Approach"
                breadMid="Astronomy"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/astronomy-lab.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <h5 className="color-red text-center">
                “Somewhere something incredible is waiting to be known”
              </h5>
              <p>
                Astronomy Club aims to equip learners to apply scientific
                reasoning to astronomical discoveries and to understand their
                effectiveness. Dealing with stars, planets, asteroids, the sun
                and the other heavenly bodies, the club offers an array of
                activities and experiments for learners to ponder over.
              </p>
              <p>
                With the able guidance of the teachers and experts from the
                organization ‘SPACE’, our learners not only explore into the
                enigmatic world of astronomy but also analyse the laws and
                theories pertinent to the universe through sky-maps, latitude
                and finders.
              </p>
              <p>
                The spacious Astronomy Lab in the school provides each learner,
                ample opportunities to understand basic phenomenon of the
                universe, conduct scientific observations, formulate and evolve
                their learning and also create samples of spatial objects such
                as asteroids and comets with the help of the raw material
                provided in the lab. Fervent discussions and debates further
                fuel the minds of our young learners.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Astronomy;
